// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  Auth: {
    identityPoolId: 'ap-northeast-1:767b8d5f-5ef8-4a2d-b2ef-9e1c5439b68b',
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_0nPnK0m5d',
    userPoolWebClientId: 'lmt2gubh7680mrs5p7tltgjsb',
  }
};

export default awsmobile;
